import { Button } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, CheckCheckIcon, ChevronLeft, ChevronRight } from "lucide-react";

const BackButton = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  return (
    <Button
      className="flex text-who items-center gap-1 mb-2 cursor-pointer"
      onClick={() => navigate(-1)}
    >
      <ChevronLeft size={20} className="text-primary" />
      <span className="text-primary font-semibold">{children}</span>
    </Button>
  );
};

export default BackButton;
